import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { FormGroupState, FormState } from '@core/constants/form.constants';
import { FormGroup } from '@angular/forms';

const initialFormState: FormState = {
    formGroups: new Map(),
};

export const FormStore = signalStore(
    { providedIn: 'root' },
    withState(initialFormState),
    withMethods((store) => ({
        updateFormGroup(id: string, formState: FormGroup): void {
            patchState(store, (state) => ({
                formGroups: updateFormData(id, formState, state.formGroups),
            }));
        },
        deleteForm(id: string): void {
            patchState(store, (state) => ({
                formGroups: deleteFormFromList(id, state.formGroups),
            }));
        },
        deleteAllForms(): void {
            patchState(store, (state) => ({
                formGroups: new Map(),
            }));
        },
    })),
);

function updateFormData(
    id: string,
    formState: FormGroup,
    formGroups: Map<string, FormGroupState>,
) {
    formGroups.set(id, {
        form: formState,
    });

    return formGroups;
}

function deleteFormFromList(
    id: string,
    formGroups: Map<string, FormGroupState>,
) {
    formGroups.delete(id);
    return formGroups;
}
